import { forwardRef, type SelectHTMLAttributes } from 'react';

import { cx } from './cx';

export type SelectProps = SelectHTMLAttributes<HTMLSelectElement>;

/**
 * Visually shares the `.mf-input` class with the Input primitive — same field
 * height, border, focus ring. Wraps a native `<select>` for accessibility +
 * keyboard nav we'd otherwise have to reimplement.
 */
export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { className, children, ...props },
  ref,
) {
  return (
    <select ref={ref} className={cx('mf-input', className)} {...props}>
      {children}
    </select>
  );
});
